import GradePage from "@/pages/GradePage";
export default function GradeGrade5() {
  return <GradePage grade="5" />;
}
